module.exports = __webpack_public_path__ + "img/award-03.b199eb96.jpg";